import { createContext } from 'react';
import { EquipmentMaintenance } from 'types/EquipmentMaintenance';
import { MaintenanceHistory } from 'types/MaintenanceHistory';
import { IMaintenanceSchedule } from 'types/IMaintenanceSchedule';

export interface IMaintenanceHistoryData {
  selectedEquipmentMaintenanceHistory?: MaintenanceHistory[];
  // Temporary solution. The entire flow for handling the maintenance schedule & intervals must be rewritten due to inability to support it.
  rawMaintenanceIntervals?: EquipmentMaintenance[];
  maintenanceIntervals?: IMaintenanceSchedule[];
  selectedInterval?: IMaintenanceSchedule;
  selectedModel?: string;
  hasNewHistoryItem: boolean;
}

export interface IMaintenanceHistoryContext {
  setMaintenanceHistoryData: (newValue: IMaintenanceHistoryData) => void;
  maintenanceHistoryData: IMaintenanceHistoryData;
}

export const MaintenanceHistoryContext = createContext(
  {} as IMaintenanceHistoryContext,
);
